import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { AccountService } from 'src/app/core/services/account.service';

@Component({
  selector: 'pgh-post-diagnostic-landing-page',
  templateUrl: './post-diagnostic-landing-page.component.html',
  styleUrls: ['./post-diagnostic-landing-page.component.scss']
})
export class PostDiagnosticLandingPageComponent implements OnInit {
  invitationCode: string;
  submitSuccess = false;
  showRetry = false;
  loadingResults$ = new BehaviorSubject<boolean>(true);
  constructor(
    private route: ActivatedRoute,
    private accountService: AccountService,
    private router: Router
  ) {
    //Hyla will pass several parameters in the query string, need to grab the 'id' which holds the value of the 
    //invitation code used by Hyla for the test
    this.route.queryParams.subscribe(queryParams => {
      this.invitationCode = queryParams['id'];
    });
  }

  ngOnInit(): void {
    this.loadDiagnosticResults(true);
  }

  loadDiagnosticResults(showRetryOnError = false) {
    this.loadingResults$.next(true);
    //need to pass the invitation code used by Hyla to the middleware in order to save the test results to Elita
    this.accountService.updateDeviceWithInfoFromDiagnosticResult(this.invitationCode)
      .subscribe({
        next: (resp) => {
          //not doing anything with successfull submit right now, just showing a message
          this.submitSuccess = true;
          this.loadingResults$.next(false);
        },
        error: (err) => {
          console.log(err);
          this.loadingResults$.next(false);
          this.showRetry = showRetryOnError;
          if (!showRetryOnError) {
            this.router.navigate(['/tech-support'], { queryParams: { headerKey: 'TechSupport_HavingTrouble' } });
          }
        }
      });
  }

  retrySubmit() {
    this.showRetry = false;
    this.submitSuccess = false;
    this.loadDiagnosticResults();
  }

  gotoLogin(): void {
    this.router.navigate(['/login']).then(
      () => { window.location.reload(); });
  }
}
